export type SuggestionType = 'address' | 'place';

export const getPointOfInterestSuggestionType = (suggestionTypes: string[]): SuggestionType => {
  return suggestionTypes.includes('premise') || suggestionTypes.includes('street_address')
    ? 'address'
    : 'place';
};
